import axios from 'axios';

export async function requestLgSnapshot({ deviceId }) {
  const response = await axios.post(`/api/site-control/targets/${deviceId}/action`, {
    action: 'lg_op_capture',
    controlMethod: 'lg_webos_remote',
    requestId: `lg-preview-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`,
  }, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }, timeout: 20000 });
  const attachment = response.data?.attachment;
  if (response.data?.success === false || !attachment) {
    throw new Error(response.data?.message || 'The LG TV did not return an image. Try Refresh Now; protected content may not be captured.');
  }
  if (!['image/jpeg', 'image/png', 'image/webp'].includes(attachment.mimeType)
    || typeof attachment.base64 !== 'string' || !attachment.base64.length
    || attachment.base64.length > 700000 || !/^[A-Za-z0-9+/=]+$/.test(attachment.base64)) {
    throw new Error('The LG TV returned an unsupported preview image.');
  }
  return { screenshot: { dataUrl: `data:${attachment.mimeType};base64,${attachment.base64}` } };
}
